import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { ApplyTicketInsuranceModal } from 'features/Ancillaries/components/ApplyTicketInsuranceModal'
import { CancelTicketInsuranceModal } from 'features/Ancillaries/components/CancelTicketInsuranceModal'
import { canBeCancelled, canBeApplied } from 'resolvers/insurance'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import IconButton from 'components/v2/IconButton'

export const TicketInsuranceActions = ({ ticketInsurance }: TSFixMe): TSFixMe => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenCancelInsuranceModal, setOpenCancelInsuranceModal] = useState(false)
  const [isOpenApplyInsuranceModal, setOpenApplyInsuranceModal] = useState(false)

  const login = useLogin()

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  const canWriteBooking = canWrite(FEATURES.BOOKING, login.accessToken.policies)
  const ticketInsuranceCanBeCancelled = canWriteBooking && canBeCancelled(ticketInsurance.insurance.status)
  const insuranceCanBeApplied =
    canWriteBooking && canBeApplied(ticketInsurance.insurance.status, !!ticketInsurance.insurance.confirmedAt)

  const handleCancelInsurance = (): TSFixMe => {
    if (ticketInsuranceCanBeCancelled) {
      setOpenDropdown(false)
      setOpenCancelInsuranceModal(true)
    }
  }

  const handleApplyInsurance = (): TSFixMe => {
    if (insuranceCanBeApplied) {
      setOpenDropdown(false)
      setOpenApplyInsuranceModal(true)
    }
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): TSFixMe => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item action onClick={handleCancelInsurance} disabled={!ticketInsuranceCanBeCancelled}>
              <FormattedMessage id="ticketsInsurance.actions.cancel" defaultMessage="Cancel" />
            </List.Item>

            <List.Item action onClick={handleApplyInsurance} disabled={!insuranceCanBeApplied}>
              <FormattedMessage id="ticketsInsurance.actions.apply" defaultMessage="Apply" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>

      {isOpenCancelInsuranceModal && (
        <CancelTicketInsuranceModal
          ticketInsurance={ticketInsurance}
          closeModal={(): TSFixMe => setOpenCancelInsuranceModal(false)}
        />
      )}

      {isOpenApplyInsuranceModal && (
        <ApplyTicketInsuranceModal
          ticketInsurance={ticketInsurance}
          closeModal={(): TSFixMe => setOpenApplyInsuranceModal(false)}
        />
      )}
    </>
  )
}
